<script>
  import {createEventDispatcher} from 'svelte';
  export let menuItems = [];

  const dispatch = createEventDispatcher();
  const onMenuClick = item => {
    menuItems = menuItems.map(i => {
      i.active = false;
      return i;
    });
    item.active = true;
    dispatch('menuClick', item);
  }
</script>
<ul>
  {#each menuItems as item}
    <li class:active={item.active === true} on:click={() => onMenuClick(item)}>{item.label}</li>
  {/each}
</ul>

<style>
  ul {
    list-style: none;
    font-size: 1.5em;
  }
  
  li {
    margin: 10px;
    padding: 5px;
    background-color: #FDFDFD;
    border-radius: 5px;
    box-shadow: 2px 2px gray;
  }

  li:hover {
    background-color: #E7964B;
    box-shadow: -2px -2px gray, 2px 2px white;  
  }
  li.active {
    background-color: #E7964B;
    box-shadow: -2px -2px gray, 2px 2px white;  
  }
</style>
